import { ReactElement } from 'react';
import { ReactComponent as UnitHintImage } from '../../../../../assets/img/overview/unitHint.svg';
import { UnitHintContainer } from './styles';
import { useTranslation } from 'react-i18next';

export function UnitHint(): ReactElement {
  const { t } = useTranslation();

  return (
    <UnitHintContainer>
      <div>
        <UnitHintImage />
      </div>
      <span>
        {t('passeMouseUnidadeVisualizarInformacoes')}
      </span>
    </UnitHintContainer>
  );
}
